import { api } from './client';
import type { DashboardData } from '../types';

export function getDashboard(): Promise<DashboardData> {
  return api('/api/dashboard');
}
